import request from '@/utils/request'

export function main(params) {
  return request({
    url: `/api/app/browser/transaction-details`,
    params,
    method: 'get'
  })
}

export function table(data) {
  return request({
    url: '/api/app/browser/asset-transaction',
    method: 'post',
    data,
  })
}